import React, {Component} from 'react';
import '../../style.css';
import {
    Card,
    Button,
    Input,
    Menu,
    Form,
    PageHeader,
    Space,
    Table,
    List,
    Modal, Radio,
} from "antd";
import {
    AppstoreOutlined,
    MailOutlined,
    EditOutlined,
    DeleteOutlined,
    EnvironmentOutlined,
    RightSquareOutlined
} from "@ant-design/icons";
import {fetchPost} from "../../static/util/fetch";
import {message} from "antd";
import Blue from '../../static/image/Blue.PNG';
import Orange from '../../static/image/Orange.PNG';
import Gray from '../../static/image/Gray.PNG';
const { Column } = Table;
class SuperSystemManage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            identity:this.props.identity,
            tabBar:1,
            fieldId:'',
            fieldOne:[],
            Technosphere:[],
            oneLevel:"",
            twoLevel:"",
            threeLevel:"",
            edit_field_visible:false,
            delete_field_visible:false,
            newOneLevel:"",
            newTwoLevel:"",
            newThreeLevel:"",
            loading:false,
            areaList:[],
            area_visible:false,
            area_edit_visible:false,
            area_delete_visible:false,
            editAreaId:'',
            deleteAreaId:'',
            userArea:'',
            newUserArea:'',
            systemName:'',
            systemColor:'',
            editSystemNameStatus:false,
        }
        this.handleChangeTabBar = this.handleChangeTabBar.bind(this);
        this.editField = this.editField.bind(this);
        this.deleteField = this.deleteField.bind(this);
        this.hideFieldModal = this.hideFieldModal.bind(this);
    }
    componentDidMount() {
        this.setState(()=>({
            loading:true,
            searchText: '',
            searchedColumn: '',
        }))
        fetchPost(global.constants.getTechnosphere,{})
            .then(
                res => {
                    if(res.code === 200) {
                        this.setState(()=>({
                            Technosphere:res.data,
                            loading:false,
                        }))
                    }else{
                        this.setState(()=>({
                            loading:false
                        }))
                    }
                }
            )
        fetchPost(global.constants.getOneLevel,{})
            .then(
                res => {
                    if(res.code === 200) {
                        this.setState(()=>({
                            fieldOne:res.data,
                        }))
                    }
                }
            )
        fetchPost(global.constants.getAllUserArea,{})
            .then(
                res=>{
                    if(res.code === 200){
                        this.setState(()=>({
                            areaList:res.data
                        }))
                    }
                }
            )
        fetchPost(global.constants.getSysConfig,{})
            .then(
                res=>{
                    if(res.code === 200){
                        this.setState(()=>({
                            systemName:res.data.systemName,
                            systemColor:res.data.systemColor
                        }))
                    }
                }
            )
    }
    handleChangeTabBar = (tabBar) => {
        this.setState({
            tabBar: tabBar
        })
    }
    addField(){
        if(this.state.oneLevel === '' ||this.state.twoLevel === ''||this.state.threeLevel === ''){
            message.info("请完善三级技术领域信息").then()
        }else{
            let params={
                oneLevel:this.state.oneLevel,
                twoLevel: this.state.twoLevel,
                threeLevel: this.state.threeLevel
            }
            fetchPost(global.constants.addTechnosphere,params)
                .then(
                    res => {
                        if(res.code === 200) {
                            message.success('添加成功！').then()
                            this.setState(()=>({
                                loading:true
                            }))
                            fetchPost(global.constants.getTechnosphere,{})
                                .then(
                                    res => {
                                        if(res.code === 200) {
                                            this.setState(()=>({
                                                Technosphere:res.data,
                                                loading:false,
                                            }))
                                        }
                                    }
                                )
                        }
                    }
                )
        }
    }
    hideFieldModal(){
        this.setState(()=>({
            edit_field_visible:false,
            delete_field_visible:false
        }))
    }
    handleEditField(e){
        const editItem =  this.state.Technosphere.find(item=>item.id === e.id)
        this.setState(()=>({
            fieldId:e.id,
            newOneLevel:editItem.oneLevel,
            newTwoLevel:editItem.twoLevel,
            newThreeLevel:editItem.threeLevel,
            edit_field_visible:true,
        }))
    }
    editField(){
        let params={
            id:this.state.fieldId,
            oneLevel:this.state.newOneLevel,
            twoLevel: this.state.newTwoLevel,
            threeLevel: this.state.newThreeLevel
        }
        fetchPost(global.constants.updateTechnosphere,params)
            .then(
                res => {
                    if(res.code === 200) {
                        message.success('修改成功！').then()
                        this.setState(()=>({
                            edit_field_visible:false,
                            loading:true
                        }))
                        fetchPost(global.constants.getTechnosphere,{})
                            .then(
                                res => {
                                    if(res.code === 200) {
                                        this.setState(()=>({
                                            Technosphere:res.data,
                                            loading:false
                                        }))
                                    }
                                }
                            )
                    }
                }
            )
    }
    handleDeleteField(e){
        this.setState(()=>({
            delete_field_visible:true,
            fieldId:e.id
        }))
    }
    deleteField(){
        fetchPost(global.constants.deleteTechnosphere, {id:this.state.fieldId})
            .then(
                res => {
                    if(res.code === 200) {
                        message.success('删除成功！').then()
                        this.setState(()=>({
                            delete_field_visible:false,
                            loading:true
                        }))
                        fetchPost(global.constants.getTechnosphere,{})
                            .then(
                                res => {
                                    if(res.code === 200) {
                                        this.setState(()=>({
                                            Technosphere:res.data,
                                            loading:false
                                        }))
                                    }
                                }
                            )
                    }
                }
            )
    }
    getFilter = (contrName) => {
        const name = contrName.map(item => [item,item]);
        //console.log(name)
        return Array.from(
            name.map(item => {
                const dataItem = {};
                [dataItem.text, dataItem.value] = item;
                return dataItem;
            }
            ),);
    };
    hideAreaModal(){
        this.setState(()=>({
            area_visible:false,
            area_edit_visible:false
        }))
    }
    handleAddArea(){
        this.setState(()=>({
            area_visible:true,
            userArea:'',
        }))
    }
    addArea(){
        if(this.state.userArea === ''){
            message.info("请输入地区").then()
        }else{
            fetchPost(global.constants.addUserArea,{userArea:this.state.userArea})
                .then(
                    res=>{
                        if(res.code === 200){
                            message.success("添加成功").then()
                            fetchPost(global.constants.getAllUserArea,{})
                                .then(
                                    res=>{
                                        if(res.code === 200){
                                            this.setState(()=>({
                                                areaList:res.data,
                                                area_visible:false
                                            }))
                                        }
                                    }
                                )
                        }
                    }
                )

        }
    }
    handleEditArea(e){
        this.setState(()=>({
            area_edit_visible:true,
            newUserArea:e.userArea,
            editAreaId:e.id
        }))
    }
    editArea(){
        let params={
            userArea:this.state.newUserArea,
            id:this.state.editAreaId
        }
        fetchPost(global.constants.updateUserArea,params)
            .then(
                res=>{
                    if(res.code === 200){
                        message.success("修改成功").then()
                        fetchPost(global.constants.getAllUserArea,{})
                            .then(
                                res=>{
                                    if(res.code === 200){
                                        this.setState(()=>({
                                            areaList:res.data,
                                            area_edit_visible:false,
                                        }))
                                    }
                                }
                            )
                    }
                }
            )
    }
    handleDeleteArea(e){
        this.setState(()=>({
            area_delete_visible:true,
            deleteAreaId:e.id
        }))
    }
    deleteArea(){
        fetchPost(global.constants.deleteUserArea,{id:this.state.deleteAreaId})
            .then(
                res=>{
                    if(res.code === 200){
                        message.success("删除成功").then()
                        fetchPost(global.constants.getAllUserArea,{})
                            .then(
                                res=>{
                                    if(res.code === 200){
                                        this.setState(()=>({
                                            areaList:res.data,
                                            area_delete_visible:false
                                        }))
                                    }
                                }
                            )
                    }
                }
            )
    }
    handleSystemName(){
        this.setState(()=>({
            editSystemNameStatus:true
        }))
    }
    editSystemName(){
        let params={
            systemName:this.state.systemName,
            systemColor: this.state.systemColor
        }
        fetchPost(global.constants.updateSysConfig,params)
            .then(
                res=>{
                    if(res.code === 200){
                        message.success('修改成功').then()
                        fetchPost(global.constants.getSysConfig,{})
                            .then(
                                res=>{
                                    if(res.code === 200){
                                        this.setState(()=>({
                                            systemName:res.data.systemName,
                                            editSystemNameStatus:false
                                        }))
                                        window.location.reload()
                                    }
                                }
                            )
                    }
                }
            )
    }
    systemColorChange(e){
        let params={
            systemName:this.state.systemName,
            systemColor: e
        }
        fetchPost(global.constants.updateSysConfig,params)
            .then(
                res=>{
                    if(res.code === 200){
                        message.success('修改成功').then()
                        fetchPost(global.constants.getSysConfig,{})
                            .then(
                                res=>{
                                    if(res.code === 200){
                                        this.setState(()=>({
                                            systemColor:res.data.systemColor,
                                        }))
                                    }
                                    window.location.reload()
                                }
                            )
                    }
                }
            )
    }
    render() {
        return (
            <div className="content-frame">
                <div className="content-form">
                    <div className="content-page-header">
                        <PageHeader
                            ghost={false}
                            title="系统管理"
                            subTitle="参数配置"
                        >
                        </PageHeader>
                    </div>
                    {/*<div className={'system-card'}>*/}
                    {/*    <Card bordered={true}*/}
                    {/*          style={{*/}
                    {/*              border:'0 solid transparent',*/}
                    {/*              borderRadius: '0.25rem',*/}
                    {/*              backgroundColor: '#fff',*/}
                    {/*              width: 300,*/}
                    {/*              height: 200,*/}
                    {/*              padding: 10,*/}
                    {/*              boxShadow: '4px 4px 2px 5px #F0F8FF ',*/}
                    {/*          }}*/}
                    {/*          actions={[*/}
                    {/*              <SettingOutlined key="setting" />,*/}
                    {/*              <EditOutlined key="edit" />,*/}
                    {/*              <EllipsisOutlined key="ellipsis" />,*/}
                    {/*          ]}*/}
                    {/*    >*/}
                    {/*        <Statistic*/}
                    {/*            title="Active"*/}
                    {/*            value={100}*/}
                    {/*            precision={2}//数值精度*/}
                    {/*            valueStyle={{ color: '#3f8600' }}*/}
                    {/*            prefix={<TeamOutlined style={{color:'#b5d3f1',fontSize:'40px'}}/>}*/}
                    {/*            suffix=""*/}
                    {/*        />*/}
                    {/*        此处可显示数据，待完善*/}
                    {/*    </Card>*/}
                    {/*</div>*/}
                    <div>
                        <Menu
                            theme="light"
                            defaultSelectedKeys={['1']}
                            mode="horizontal"
                        >
                            <Menu.Item key='1' onClick={this.handleChangeTabBar.bind(this, 1)} icon={<MailOutlined />}>
                                公司技术领域设置
                            </Menu.Item>
                            <Menu.Item key='2' onClick={this.handleChangeTabBar.bind(this, 2)} icon={<EnvironmentOutlined />}>
                                用户地区设置
                            </Menu.Item>
                            <Menu.Item key='3' style={{display:this.state.identity === "1" && "none"}} onClick={this.handleChangeTabBar.bind(this, 3)} icon={<AppstoreOutlined />}>
                                系统界面设置
                            </Menu.Item>
                            {/*<Menu.Item key='4' onClick={this.handleChangeTabBar.bind(this, 4)} icon={<AppstoreOutlined />}>*/}
                            {/*    其他设置*/}
                            {/*</Menu.Item>*/}
                        </Menu>
                        {
                            this.state.tabBar === 1 &&(
                                <Space direction="vertical" className="content-style" >
                                    <Card bordered={true} style={{border:'solid  1px #7F9DB9'}} >
                                        <Form>
                                            <Form.Item label="一级目录" name="oneLevel" rules={[{ required: true, message: '请输入一级目录!' }]}>
                                                <Input
                                                    onChange={(e) => this.oneLevelChange(e.target.value)}
                                                /></Form.Item>
                                            <Form.Item label="二级目录" name="twoLevel" rules={[{ required: true, message: '请输入一级目录!' }]}>
                                                <Input
                                                    onChange={(e) => this.twoLevelChange(e.target.value)}
                                                /></Form.Item>
                                            <Form.Item label="三级目录" name="threeLevel" rules={[{ required: true, message: '请输入一级目录!' }]}>
                                                <Input
                                                    onChange={(e) => this.threeLevelChange(e.target.value)}
                                                /></Form.Item>
                                            <Button type={'primary'} style={{marginBottom:'10px'}} onClick={this.addField.bind(this)}>添加技术领域</Button>
                                        </Form>
                                        <Table dataSource={this.state.Technosphere} loading={this.state.loading}>
                                            <Column
                                                align="center"
                                                title={<p className="list-column-style">序号</p>}
                                                width="80"
                                                render={
                                                    (text,record,index)=>(`${index+1}`)} />
                                            <Column
                                                align="center"
                                                title={<p className="list-column-style">一级目录</p>}
                                                dataIndex="oneLevel"
                                                key="oneLevel"
                                                filters={
                                                    this.getFilter(this.state.fieldOne)
                                                }
                                                onFilter={(value, record) => record.oneLevel.indexOf(value) === 0}
                                            />
                                            <Column
                                                align="center"
                                                title={<p className="list-column-style">二级目录</p>}
                                                dataIndex="twoLevel"
                                                key="twoLevel" />
                                            <Column
                                                align="center"
                                                title={<p className="list-column-style">三级目录</p>}
                                                dataIndex="threeLevel"
                                                key="threeLevel"
                                            />
                                            <Column
                                                align="center"
                                                title={<p className="list-column-style">操作</p>}
                                                key="action"
                                                render={(text, record) => (
                                                    <Space size="middle">
                                                        <Button
                                                            type="primary"
                                                            icon={<EditOutlined />}
                                                            onClick={this.handleEditField.bind(this,record)}
                                                        >编辑</Button>
                                                        <Button
                                                            type="primary"
                                                            icon={<DeleteOutlined />}
                                                            onClick={this.handleDeleteField.bind(this,record)}
                                                        >删除</Button>
                                                    </Space>
                                                )}
                                            />
                                        </Table>
                                    </Card>
                                    <Modal
                                        visible={this.state.edit_field_visible}
                                        title={'编辑技术领域'}
                                        onOk={this.editField}
                                        onCancel={this.hideFieldModal}
                                        destroyOnClose
                                        footer={[
                                            <Button key="back" onClick={this.hideFieldModal}>
                                                取消
                                            </Button>,
                                            <Button key="submit" type="primary"  onClick={this.editField}>
                                                提交
                                            </Button>,
                                        ]}
                                    >
                                        <Form>
                                            <Form.Item label="一级目录" name="newOneLevel">
                                                <Input
                                                    defaultValue={this.state.newOneLevel}
                                                    onChange={(e) => this.newOneLevelChange(e.target.value)}
                                                /></Form.Item>
                                            <Form.Item label="二级目录" name="newTwoLevel">
                                                <Input
                                                    defaultValue={this.state.newTwoLevel}
                                                    onChange={(e) => this.newTwoLevelChange(e.target.value)}
                                                /></Form.Item>
                                            <Form.Item label="三级目录" name="newThreeLevel">
                                                <Input
                                                    defaultValue={this.state.newThreeLevel}
                                                    onChange={(e) => this.newThreeLevelChange(e.target.value)}
                                                /></Form.Item>
                                        </Form>
                                    </Modal>
                                    <Modal
                                        visible={this.state.delete_field_visible}
                                        title={'温馨提示'}
                                        onOk={this.deleteField}
                                        onCancel={this.hideFieldModal}
                                        destroyOnClose
                                        footer={[
                                            <Button key="back" onClick={this.hideFieldModal}>
                                                取消
                                            </Button>,
                                            <Button key="submit" type="primary"  onClick={this.deleteField}>
                                                确定
                                            </Button>,
                                        ]}
                                    >
                                        <div>确定删除该技术领域吗？</div>
                                    </Modal>
                                </Space>
                            )
                        }
                        {
                            this.state.tabBar === 2 && (
                                <Space direction="vertical" className="content-style" >
                                    <Card bordered={true} style={{border:'solid  1px #7F9DB9'}} >
                                        <List
                                            header={<div style={{fontWeight:'bolder',fontSize:'15px'}}>现有的用户地区</div>}
                                            footer={<div>
                                                <Button type={'primary'} style={{marginBottom:'10px'}} onClick={this.handleAddArea.bind(this)}>添加地区</Button>
                                            </div>}
                                            dataSource={this.state.areaList}
                                            style={{width:'100'}}
                                            renderItem={item => (
                                                <List.Item
                                                    actions={[
                                                        <a key="list-edit" onClick={this.handleEditArea.bind(this,item)}>编辑</a>,
                                                        <a key="list-delete" onClick={this.handleDeleteArea.bind(this,item)}>删除</a>]}>
                                                    {/*<Typography.Text mark> </Typography.Text> */}
                                                    {item.userArea}
                                                </List.Item>
                                            )}
                                        />
                                    </Card>
                                    <Modal
                                        visible={this.state.area_visible}
                                        title={'添加地区'}
                                        onOk={this.addArea.bind(this)}
                                        onCancel={this.hideAreaModal.bind(this)}
                                        destroyOnClose
                                        footer={[
                                            <Button key="back" onClick={this.hideAreaModal.bind(this)}>
                                                取消
                                            </Button>,
                                            <Button key="submit" type="primary"  onClick={this.addArea.bind(this)}>
                                                添加
                                            </Button>,
                                        ]}
                                    >
                                        <Form>
                                            <Form.Item label="地区" name="userArea" rules={[{ required: true, message: '请输入一级目录!'}]}>
                                                <Input
                                                    defaultValue={this.state.userArea}
                                                    onChange={(e) => this.userAreaChange(e.target.value)}
                                                /></Form.Item>
                                        </Form>
                                    </Modal>
                                    <Modal
                                        visible={this.state.area_edit_visible}
                                        title={'修改地区'}
                                        onOk={this.editArea.bind(this)}
                                        onCancel={this.hideAreaModal.bind(this)}
                                        destroyOnClose
                                        footer={[
                                            <Button key="back" onClick={this.hideAreaModal.bind(this)}>
                                                取消
                                            </Button>,
                                            <Button key="submit" type="primary"  onClick={this.editArea.bind(this)}>
                                                提交
                                            </Button>,
                                        ]}
                                    >
                                        <Form>
                                            <Form.Item label="地区" name="userArea">
                                                <Input
                                                    defaultValue={this.state.newUserArea}
                                                    onChange={(e) => this.newUserAreaChange(e.target.value)}
                                                /></Form.Item>
                                        </Form>
                                    </Modal>
                                    <Modal
                                        visible={this.state.area_delete_visible}
                                        title={'温馨提示'}
                                        onOk={this.deleteArea.bind(this)}
                                        onCancel={this.hideAreaModal.bind(this)}
                                        destroyOnClose
                                        footer={[
                                            <Button key="back" onClick={this.hideAreaModal.bind(this)}>
                                                取消
                                            </Button>,
                                            <Button key="submit" type="primary"  onClick={this.deleteArea.bind(this)}>
                                                确定
                                            </Button>,
                                        ]}
                                    >
                                        <div>确定删除该地区吗？</div>
                                    </Modal>
                                </Space>

                            )
                        }
                        {
                            this.state.tabBar === 3 && (
                                <Space direction="vertical" className="content-style" >
                                    <Card bordered={true} style={{border:'solid  1px #7F9DB9'}} >
                                        <Form>
                                            <Form.Item label="系统名称" name="systemName">
                                                {
                                                    this.state.editSystemNameStatus === true?
                                                        <Input
                                                           style={{width:'200px'}}
                                                            defaultValue={this.state.systemName}
                                                            onChange={(e) => this.systemNameChange(e.target.value)}
                                                        />:this.state.systemName
                                                }
                                                <Button
                                                    style={{marginLeft:'10px'}}
                                                    icon={<EditOutlined/>}
                                                    onClick={this.handleSystemName.bind(this)}>编辑</Button>
                                                <Button
                                                    style={{marginLeft:'10px'}}
                                                    icon={<RightSquareOutlined/>}
                                                    onClick={this.editSystemName.bind(this)}>提交</Button>
                                            </Form.Item>
                                            <Form.Item label="系统主题" name="systemColor">
                                                <Radio.Group
                                                    name="systemColor"
                                                    defaultValue={this.state.systemColor}
                                                    onChange={(e) => this.systemColorChange(e.target.value)}
                                                >
                                                    <Radio value={1}>
                                                        <img style={{width:'100px',height:'50px'}} src={Blue} alt={'blue'}/>
                                                    </Radio>
                                                    <Radio value={2}>
                                                        <img style={{width:'100px',height:'50px'}} src={Orange} alt={'orange'}/>
                                                    </Radio>
                                                    <Radio value={3}>
                                                        <img style={{width:'100px',height:'50px'}} src={Gray} alt={'gray'}/>
                                                    </Radio>
                                                </Radio.Group>
                                            </Form.Item>
                                        </Form>
                                    </Card>
                                </Space>
                            )
                        }
                    </div>
                </div>
            </div>
        )
    }
    oneLevelChange(e){
        this.setState({
            oneLevel:e
        })
    }
    twoLevelChange(e){
        this.setState({
            twoLevel:e
        })
    }
    threeLevelChange(e){
        this.setState({
            threeLevel:e
        })
    }
    newOneLevelChange(e){
        this.setState({
            oneLevel:e
        })
    }
    newTwoLevelChange(e){
        this.setState({
            newTwoLevel:e
        })
    }
    newThreeLevelChange(e){
        this.setState({
            newThreeLevel:e
        })
    }
    userAreaChange(e){
        this.setState({
            userArea:e
        })
    }
    newUserAreaChange(e){
        this.setState({
            newUserArea:e
        })
    }
    systemNameChange(e){
        this.setState(()=>({
            systemName:e
        }))
    }
}

export default SuperSystemManage;